module.exports = __webpack_public_path__ + "static/media/selectArrowIcon.7b885508.svg";